import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Input } from 'reactstrap';
import { RootState } from '../../stores/store';
import { selectedAll } from '../../stores/tables/selectors';
import TableColumn from '../table/TableColumn';
import { selected } from '../../stores/tables/selectors';

interface Props {
    tableKey: string;
    itemIds: string[]

    checked: boolean;
    selectAll: () => void;
    deselectAll: () => void;
}

class TableSelectionColumn extends React.Component<Props> {
    public render() {
        return (
            <TableColumn >
                <Input
                    type="checkbox"
                    checked={this.props.checked}
                    onChange={(e) => e.target.checked ?
                        this.props.selectAll() : this.props.deselectAll()}
                />
            </TableColumn>
        );
    }
}

const mapStateToProps = (state: RootState, props: { tableKey: string, itemIds: string[] }) => ({
    checked: !props.itemIds.some(item => !selected(state, props.tableKey).includes(item))
});

export default connect(mapStateToProps)(TableSelectionColumn);